import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function PendingApproval() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        maxWidth: '500px',
        width: '100%',
        padding: '40px',
        textAlign: 'center'
      }}>
        {/* Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 24px',
          background: 'linear-gradient(135deg, #FFA500, #FF6B00)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '40px'
        }}>
          ⏳
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1a202c',
          marginBottom: '16px'
        }}>
          Account Pending Approval
        </h1>

        {/* Message */}
        <p style={{
          fontSize: '16px',
          color: '#718096',
          lineHeight: '1.6',
          marginBottom: '24px'
        }}>
          Your account has been created successfully! However, it requires admin approval before you can access the application.
        </p>

        {/* Info Box */}
        <div style={{
          background: '#FFF9E6',
          border: '1px solid #FFE066',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '24px',
          textAlign: 'left'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#856404',
            margin: 0,
            lineHeight: '1.5'
          }}>
            <strong>What happens next?</strong><br />
            • An administrator will review your registration<br />
            • You'll receive access once approved<br />
            • Please check back later or contact your administrator
          </p>
        </div>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '14px 24px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.5)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
          }}
        >
          Logout
        </button>

        {/* Footer */}
        <p style={{
          marginTop: '24px',
          fontSize: '14px',
          color: '#a0aec0'
        }}>
          Need help? Contact your administrator
        </p>
      </div>
    </div>
  );
}

export default PendingApproval;
